import React from 'react';

import { Box, Card, H1, H3, ListRow, Separator } from '@betterment/samba-react';
import { CardLoader, PayrollConfigsList, RecurringTransactionsConfig } from '@betterment/shared-components';

import { useRecurringTransactionConfigsQuery } from './hooks';

import urlBuilder from '../../../../Shared/url-builder';
import { ImpersonationLink } from '../../ImpersonationLink';

export const RecurringTransactionOverviewCard: React.FC<{ accountId: string }> = ({ accountId }) => {
  const { isLoading, recurringTransactionConfigs, payrollContributionConfigs, clientId, legacySubAccountIds } =
    useRecurringTransactionConfigsQuery(accountId);

  if (isLoading) return <CardLoader />;

  const hasPayrollContributions = payrollContributionConfigs && payrollContributionConfigs.length > 0;
  const hasRecurringContributions = recurringTransactionConfigs && recurringTransactionConfigs.length > 0;

  const hasAnyRecurringTransactions = hasRecurringContributions || hasPayrollContributions;
  if (!hasAnyRecurringTransactions || !clientId) return null;

  const isWithdrawal = (sourceLegacySubAccountId: number) => {
    return !!legacySubAccountIds?.includes(sourceLegacySubAccountId);
  };

  return (
    <Card css={{ padding: 'space.300', display: 'grid', gap: 'space.300', width: '100%' }}>
      <Card.Header>
        <H3 css={{ textStyle: { base: 'title100', md: 'title200' } }}>Recurring transactions</H3>
      </Card.Header>
      <Separator />
      <Card.Content>
        <Box css={{ display: 'grid', gap: 'space.300', marginTop: 'space.25' }}>
          {hasPayrollContributions && (
            <>
              <ListRow css={{ padding: 'space.25' }}>
                <ListRow.LeadingContent>
                  <H1 variant="title100">401(k) contribution settings</H1>
                </ListRow.LeadingContent>
              </ListRow>

              <PayrollConfigsList configs={payrollContributionConfigs} />
            </>
          )}

          {hasRecurringContributions && (
            <>
              {hasPayrollContributions && (
                <>
                  <Separator css={{ marginTop: 0 }} />
                  <ListRow css={{ padding: 'space.25' }}>
                    <ListRow.LeadingContent>
                      <H1 variant="title100">Other transactions</H1>
                    </ListRow.LeadingContent>
                  </ListRow>
                </>
              )}

              {recurringTransactionConfigs.map(config => (
                <ListRow key={config.id} css={{ padding: 'space.25' }}>
                  <RecurringTransactionsConfig config={config} isWithdrawal={isWithdrawal} />
                </ListRow>
              ))}
            </>
          )}
          <Separator />
          <ImpersonationLink
            showModal={false}
            url={urlBuilder.getImpersonateClientPage.absolute({
              clientId,
              deep_link_path: `/app/account/${accountId}`,
            })}
            label="See details"
            variant="textPrimary"
          />
        </Box>
      </Card.Content>
    </Card>
  );
};
